exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-ea6b9a1c] {\n  color: #232323;\n  font-size: 24px;\n  text-align: center;\n}\n.rate-picklr[data-v-ea6b9a1c] {\n  cursor: pointer;\n  margin-bottom: 45px;\n}\n.rate-picklr span[data-v-ea6b9a1c] {\n  display: inline-block;\n}\n.rate-picklr img[data-v-ea6b9a1c] {\n  width: 33px;\n  height: 31px;\n  margin: 0 8px;\n}\ntable.user-pickl-table>tr[data-v-ea6b9a1c] {\n  border: solid 1px gainsboro;\n}\ntable.user-pickl-table>tr>td[data-v-ea6b9a1c] {\n  padding: 5px 5px;\n}\n", ""]);

// exports
